var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("公司员工岗位管理")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "base-search-container" },
      [_c("swb-staff-role-search", { on: { queryHandler: _vm.queryHandler } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout mt10" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.staffList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "name",
                label: "员工姓名",
                align: "center",
                width: "140"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "user.phoneNo",
                label: "用户手机号",
                align: "center",
                width: "140"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "user.nickName",
                label: "用户昵称",
                align: "center",
                width: "140"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "contactTel",
                label: "联系电话",
                align: "center",
                width: "140"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "user.idCertNo",
                label: "身份证号",
                align: "center",
                width: "200"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "enrollDate",
                label: "入职时间",
                align: "center",
                width: "180"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "quit",
                label: "是否离职",
                align: "center",
                width: "180"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.quit
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("是")
                          ])
                        : _c("span", [_vm._v("否")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "quitDate",
                label: "离职时间",
                align: "center",
                width: "180"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "id", label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.checkActionPerm("staffRole")
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.showStaffRoleDialog(rows.row)
                                }
                              }
                            },
                            [_vm._v("分配岗位")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout mt10" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "prev, pager, next, jumper, sizes, total"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53a8f5d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a8f5d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/StaffRole.vue
// module id = 3477
// module chunks = 0